// ** Chart.js Registration
// Chart.js v3+ requires manual registration of components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  RadialLinearScale,
  Filler,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

// Register all Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement, // This is needed for Doughnut and Pie charts
  RadialLinearScale,
  Filler,
  Tooltip,
  Legend,
  Title
);

export default ChartJS;
